var _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSkeletonXs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 288,
    height: 348,
    viewBox: "0 0 288 348",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 244,
    width: 174.129,
    height: 14,
    rx: 7,
    fill: "#F2F2F2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 304,
    width: 174.129,
    height: 14,
    rx: 7,
    fill: "#F2F2F2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 274,
    width: 102.794,
    height: 14,
    rx: 7,
    fill: "#F2F2F2"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 334,
    width: 102.794,
    height: 14,
    rx: 7,
    fill: "#F2F2F2"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    y: 204,
    width: 238.818,
    height: 24,
    rx: 12,
    fill: "#F2F2F2"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 288,
    height: 180,
    rx: 10,
    fill: "#F2F2F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkeletonXs);
export default __webpack_public_path__ + "static/media/skeleton_xs.89f3b3f15341e84df5fb082b564022bf.svg";
export { ForwardRef as ReactComponent };